module.exports = __webpack_public_path__ + "media/shmoke.3002c123.mp3";